import AjaxLoad from './../../components/ajax-load/ajax-load';
import { createElementFromHTML } from '../../utilities/js/helper';

class JobsPagination {
    constructor (element, options) {
        this.$jobsPagination = element;

        const settings = {
            onSubmitted: null,
            content: this.$jobsPagination.querySelector('[data-jobs-pagination="content"]')
        };

        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$page = this.$jobsPagination.querySelectorAll('[data-pagination="page"]');

        for (let i = 0; i < this.$page.length; i++) {
            this.$page[i].addEventListener('click', (event) => {
                event.preventDefault();

                this.setPage(this.$page[i].href);
            });
        }
    }

    setPage (uri) {
        new AjaxLoad(uri, { // eslint-disable-line
            onSuccess: (resultText) => {
                this.settings.content.innerHTML = '';
                let $result = createElementFromHTML(resultText);

                $result = $result.querySelector('[data-jobs-pagination="content"]');

                if ($result) {
                    this.settings.content.innerHTML = $result.innerHTML;
                    // this.setEvents();
                }

                if (typeof this.settings.onSubmitted === 'function') {
                    this.settings.onSubmitted(this.$jobsPagination);
                }
            }
        });
    }
}

export { JobsPagination };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $jobPagination = $context.querySelectorAll('[data-jobs-pagination="root"]');
        for (let i = 0; i < $jobPagination.length; i++) {
            const jobPagination = new JobsPagination($jobPagination[i], {
                loader: window.OPTIONS.loader,
                onSubmitted: (result) => {
                    window.initContent(result);
                    jobPagination.initialize();
                }
            });

            jobPagination.initialize();
        }
    }
});
